import { APIGet, APIPost, APIPut, APIDelete, APIUrl, AdminType, StatusCode } from "api/protocols";
import { CancelToken } from "axios";
import { IProductGroup, IProductInGroup } from "redux/reducers/models/groups";

const apiVersion = "2024-04";
const adminType = "facility-admin";
const baseUrl = "/" + apiVersion + "/" + adminType + "/product";

export type TPostProductGroup = { title: string; type: string; parent_id?: number };
export type TPutProductGroup = { id: number; title?: string; type?: string; parent_id?: number };
export type TDeleteProductGroup = { id: number };

// GET Product Groups
export async function GetProductGroups(params: { id?: number }, useGlobalLoader: boolean, token?: CancelToken) {
  return await APIGet<IProductGroup[]>(
    APIUrl(AdminType.FacilityAdmin, "/product/group"),
    params,
    useGlobalLoader,
    token,
  );
}

export async function PutProductGroup(params: TPutProductGroup, useGlobalLoader: boolean, token?: CancelToken) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/product/group"), params, useGlobalLoader, token);
}

export async function PostProductGroup(params: TPostProductGroup, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/product/group"), params, useGlobalLoader);
}

export async function DeleteProductGroup(params: TDeleteProductGroup, useGlobalLoader: boolean) {
  return await APIDelete(APIUrl(AdminType.FacilityAdmin, "/product/group"), params, useGlobalLoader);
}

interface IProductGroupProductRes {
  data: any;
  status: StatusCode;
}
interface IDeleteProductGroupProduct {
  group_id: number;
  product_ids: Array<number>;
}

interface IProductGroupProductPosition {
  product_id: number;
  position: number;
}

interface IPutProductGroupProduct {
  group_id: number;
  products: IProductGroupProductPosition[];
}

interface IPostProductGroupProduct {
  group_id: number;
  product_ids: Array<number>;
}

interface ICopyProductGroupProducts {
  group_ids: Array<number>;
  product_ids: Array<number>;
}

export async function GetProductsInGroup(params: { group_id?: number }, useGlobalLoader: boolean, token?: CancelToken) {
  return await APIGet<IProductInGroup[]>(
    APIUrl(AdminType.FacilityAdmin, "/product/group/product"),
    params,
    useGlobalLoader,
    token,
  );
}

export async function PutProductGroupProduct(
  params: IPutProductGroupProduct,
  useGlobalLoader: boolean,
): Promise<IProductGroupProductRes> {
  return await APIPut(baseUrl + "/group/product", params, useGlobalLoader);
}

export async function PostProductGroupProduct(
  params: IPostProductGroupProduct,
  useGlobalLoader: boolean,
): Promise<IProductGroupProductRes> {
  return await APIPost(baseUrl + "/group/product", params, useGlobalLoader);
}

export async function DeleteProductGroupProduct(
  params: IDeleteProductGroupProduct,
  useGlobalLoader: boolean,
): Promise<IProductGroupProductRes> {
  return await APIDelete(baseUrl + "/group/product", params, useGlobalLoader);
}

export async function CopyProductGroupProducts(
  params: ICopyProductGroupProducts,
  useGlobalLoader: boolean,
): Promise<IProductGroupProductRes> {
  return await APIPost(baseUrl + "/group/product" + "/copy", params, useGlobalLoader);
}
